import { render } from "./IconPickerDialog.vue?vue&type=template&id=ba773a08&scoped=true"
import script from "./IconPickerDialog.vue?vue&type=script&lang=js"
export * from "./IconPickerDialog.vue?vue&type=script&lang=js"

import "./IconPickerDialog.vue?vue&type=style&index=0&id=ba773a08&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba773a08"]])

export default __exports__